module.exports = __webpack_public_path__ + "img/doc_shares.7050b48c.jpg";